// extracted by mini-css-extract-plugin
module.exports = {"logosBlock":"logos-module--logos-block--2JSL2","logosItem":"logos-module--logos-item--3gwL2"};